import React from 'react';
import { useParams } from 'react-router';
import { createURL } from '@sm/utils';
import useTrackingDetails from '~pricing/hooks/useTrackingDetails';
import { PackageType } from '~shared/types/pricing/package';
import { usePackages } from '~shared/hooks/usePackages';

import ROUTE_CONFIG from './routes';
import NavItem from './NavItem';
import useNavigationStyles from './useStyles';

import { NavRouteParams } from './types';

export default function Navigation(): React.ReactElement {
  const { canonicalPath = PackageType.Teams, subPath = '' } = useParams<NavRouteParams>();
  const { Container, List } = useNavigationStyles();
  const { comparePlans } = usePackages();
  const { pageUtSource } = useTrackingDetails();

  return (
    <nav className={Container} data-testid="Navigation__Packages">
      {!comparePlans && (
        <ul className={List} role="tablist">
          {Object.keys(ROUTE_CONFIG).map(routeName => {
            const route = ROUTE_CONFIG[routeName as keyof typeof ROUTE_CONFIG];
            const navProps = {
              title: route.title,
              selected:
                canonicalPath === route.packageType ||
                (canonicalPath === 'educational' && route.packageType === 'individual')
                  ? 'selected'
                  : '',
              url: createURL(`${route.path}/${subPath}`, { ut_source: pageUtSource }),
            };
            return <NavItem {...navProps} key={routeName} />;
          })}
        </ul>
      )}
    </nav>
  );
}
